module.exports = __webpack_public_path__ + "img/NG_Wenze_2024.c5c7e35c.jpg";